module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAAACCAYAAACjUQlUAAAA10lEQVQ4T62Ry05DMQxET1IQLCp1wc/y0yyQkErzMho7QdFddAGNFCUe23nMSfaO8b+h/nXG2u/amPljzdK17vu+xR1jkBkYDVAu1oRyijWr1yVuM6+4kymYz0qmzf1t1lVfB4or8O15KB5HX+HkWvRmv0t6o9F5cV1vbxR/j945eKbz6p7E374wzhifGBeMD4y3X89UQ3oQCJ11hHAP0A5ngdAnNe6BUK1M20EIzIIUpkVN2wyV6WFuGC1gASKMlXZluBZTYDr1ACLO3UFUOk8TwoLxBxA/kx7HCYflrAQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dyou.png
// module id = ByPx
// module chunks = 18